export function planModuleDblClick({ resolvedModule, moduleListOpen }) {
  if (!resolvedModule) {
    return { stopZoom: false, openPencil: false };
  }
  return {
    stopZoom: true,
    openPencil: !!moduleListOpen
  };
}
